import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';

// The header's bottom border sits below its cells, so the body starts this
// much lower than the header cell height callers estimate with.
export const TABLE_HEADER_BORDER_WIDTH = 1;

export interface TableHeaderRowProps {
  children: React.ReactNode;
}

export const TableHeaderRow: React.FC<TableHeaderRowProps> = ({ children }) => {
  const [styles] = useStyles();

  return (
    <View role="row" style={styles.container}>
      {children}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    borderBottomWidth: TABLE_HEADER_BORDER_WIDTH,
    borderColor: theme.sk.color.border.primary,
    flexDirection: 'row',
  },
}));
